module.exports = __webpack_public_path__ + "img/qiaoqian.b0ba7df7.png";